import { css } from "styled-components"
import {
  fadeOutAnim,
  trainApearAnim,
  trainRemoveAnim,
} from "./TransitionsKeyframes"

export const trainRemove = css`
  animation: ${trainRemoveAnim} 0.167s forwards;
  animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
`
export const trainAppear = css`
  animation: ${trainApearAnim} 0.167s 1 forwards;
  animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
`
export const fadeOut = css`
  animation: ${fadeOutAnim} 0.5s infinite;
`
